export default {
      id: "quote-usage",
      viewBox: "0 0 43 31",
      url: "../../assets/" + "sprite.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }